<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">


            <div v-if="modalSolicitacaoVerba" class="tingle-modal modal-solicitacao-verba modal-default tingle-modal--visible tingle-modal--overflow" style="">
                <div class="tingle-modal-box">
                    <div class="tingle-modal-box__content">

                        <form method="post" style="width: 100%;" v-on:submit.prevent="submitSolicitacaoVerba" novalidate>
                            <div class="row">
                                <div class="col-xs-12 margin-bottom-20">
                                    <h3>
                                        <i class="las la-money-bill"></i> Gerar requisição de verba
                                    </h3>
                                </div>
                                <div class="col-xl-12">
                                    <div class="row" v-for="(item, index) in modalSolicitacaoVerba.solicitacaoVerba">
                                        <div class="col-lg-5 col-xs-6 col-xl-4 col-md-6">
                                            <div class="submit-field">
                                                <h5>Valor a ser solicitado (R$):</h5>
                                                <money @keyup.native="checkValoresSolicitacaoVerba" v-bind="$root.config.money" style="max-width: 150px;" type="tel" v-model="item.valor" name="valor" class="with-border"></money>            
                                            </div>
                                        </div>   
                                        <div class="col-lg-6 col-xs-10 col-xl-6 col-md-6" style="padding-right: 0px;">
                                            <div class="submit-field">
                                                <h5>Centro de custo de <b>origem</b>:</h5>
                                                <select class="with-border" v-model="item.centroCusto">
                                                    <option default="" value="">Selecione..</option>
                                                    <option v-for="(item, index) in centroCusto.itens" :key="'centro-custo' + item.CD_CENTRO_CUSTO" :value="item.CD_CENTRO_CUSTO">{{item.DS_CENTRO_CUSTO}}</option>
                                                </select>
                                            </div>
                                        </div>   
                                        <div class="col-xl-1 col-xs-1">
                                            <a class="click" v-if="index >= 1" v-on:click="delSolicitacaoVerbaItem(item)" style="position: absolute; top: 30%; font-size: 40px; color: red;">
                                                <i class="las la-times"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <a class="click" v-on:click="addSolicitacaoVerbaItem()">
                                        <i class="las la-plus"></i>
                                        Adicionar mais um centro de custo
                                    </a>                               
                                </div>
                                <div class="col-xl-12 margin-top-20">
                                    <button type="submit" class="button color-green big">
                                        <i class="las la-save"></i> 
                                        Salvar requisição
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <a class="close click" v-on:click="modalSolicitacaoVerba = false;"><i class="las la-times"></i></a>
                </div>

            </div>


            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <div class="hidden-xs">    
                        <center>
                            <img src="static/config/logo.png" class="logo-inicio">
                        </center>
                    </div>      

                    <div class="row margin-bottom-30 hidden-xs">
                        <div class="col-xl-12">
                            <button class="button small gray" type="button" v-on:click="$root.back()">
                                <i class="las la-arrow-left"></i> Voltar
                            </button>
                        </div>
                    </div>

                    <!-- Dashboard Headline -->
                    <div v-if="data.CLINIC_PEDIDOS_APROVACAO_V" class="dashboard-headline margin-bottom-20">
                        <h3>
                            <img src="static/images/icones/receipt.png" style="height: 50px">
                            Detalhes da solicitação <span class="dashboard-status-button gray" style="display: inline-block;">{{data.CLINIC_PEDIDOS_APROVACAO_V.NR_DOCUMENTO}}</span>
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row" v-if="data.CLINIC_PEDIDOS_APROVACAO_V">
                       
                        <div v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'P'" class="col-xl-2 col-lg-3 col-md-3 margin-bottom-10 col-xs-6">
                            <button v-on:click="aprovar()" type="button" class="button small color-green " style="width: 100%; display: block;">
                                <i class="las la-check"></i>
                                Aprovar<br class="hidden-xl hidden-lg hidden-md"> solicitação
                            </button> 
                        </div>
                        <div v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'P'" class="col-xl-2 col-lg-3 col-md-3 margin-bottom-10 col-xs-6">
                            <button v-on:click="negar()" type="button" class="button small color-red " style="width: 100%; display: block;">
                                <i class="las la-ban"></i>
                                Reprovar<br class="hidden-xl hidden-lg hidden-md"> solicitação
                            </button>  
                        </div>             
                            
                        <div class="col-xl-12 margin-bottom-40 margin-top-10">
                            <div class="table-scroll" style="overflow-x: scroll; border: 1px solid #ddd">

                                <table class="table table-color-primary table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 70px; width: 70px;">
                                            Número
                                        </th>                                                                  
                                        <th style="min-width: 200px;">
                                            Solicitante
                                        </th>
                                        <th style="min-width: 200px; width: 200px;">
                                            Tipo
                                        </th>
                                        <th style="min-width: 200px; width: 200px;" >
                                            Centro de custo
                                        </th>   
                                        <th style="min-width: 200px; width: 200px;">
                                            Origem
                                        </th>
                                        <th style="min-width: 100px; width: 100px;">
                                            Status
                                        </th>                                        
                                        <th style="min-width: 100px; width: 100px;">
                                            Data de entrega
                                        </th>
                                    </thead>
                                    <tbody>   

                                        <tr>
                                            <td data-label="">
                                                <span class="hidden-xl hidden-lg" style="font-size: 16px; font-weight: 500">Número: #{{data.CLINIC_PEDIDOS_APROVACAO_V.NR_DOCUMENTO}}</span><span style="font-size: 16px; font-weight: 500;" class="hidden-xs">{{data.CLINIC_PEDIDOS_APROVACAO_V.NR_DOCUMENTO}}</span>
                                            </td>
                                            <td data-label="Solicitante">
                                                {{data.CLINIC_PEDIDOS_APROVACAO_V.SOLICITANTE}}
                                            </td>
                                            <td data-label="Tipo">
                                               {{data.CLINIC_PEDIDOS_APROVACAO_V.IE_TIPO}}
                                            </td>
                                            <td data-label="Centro de custo">
                                               {{data.CLINIC_PEDIDOS_APROVACAO_V.DS_CENTRO_CUSTO}}
                                            </td>                         
                                            <td data-label="Origem">
                                               {{data.CLINIC_PEDIDOS_APROVACAO_V.ITEM_SERVICO}}
                                            </td>    
                                            <td class="td-50 td-50-l" data-label="Status">
                                               <span v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'P'" class="dashboard-status-button color-orange">Pendente</span>
                                               <span v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'B'" class="dashboard-status-button color-blue">Baixado</span>
                                               <span v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'A'" class="dashboard-status-button color-green">Aprovado</span>
                                               <span v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'R'" class="dashboard-status-button color-red">Reprovado</span>
                                            </td>                                                      
                                            <td class="td-50" data-label="Data de entrega" style="min-height: 60px;">
                                               {{data.CLINIC_PEDIDOS_APROVACAO_V.DT_ENTREGA | formatDate2}}
                                            </td>  
                                            <td class="hidden-xl hidden-lg hidden-md" style="padding: 1px !important"></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        <div class="col-xl-12" v-if="data.financeiroMovimentacoes.length > 0 && ($root.user.tipo == 'admin' || $root.user.tipo == 'gerente')">
                            <div  class="row">

                                <div class="col-xl-12">
                                    <div class="dashboard-headline margin-bottom-20">
                                        <h3>
                                            <img src="static/images/icones/payment.png" style="height: 50px">
                                            Requisições de verba
                                        </h3>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-xl-12 col-lg-12 margin-top-10 margin-bottom-40">


                                    <div class="table-scroll" style="overflow-x: scroll; border: 1px solid #ddd">

                                        <table class="table table-bordered table-bordered-default table-responsive">
                                            <thead>
                                                <th style="min-width: 50px; width: 50px;">
                                                    ID
                                                </th>
                                                <th style="min-width: 100px;">
                                                    Solicitado por
                                                </th>                                                
                                                <th style="min-width: 200px; width: 200px;">
                                                    Centro de custo de origem
                                                </th>
                                                <th style="min-width: 200px; width: 200px;">
                                                    Centro de custo de destino
                                                </th>    
                                                <th style="min-width: 200px; width: 200px;">
                                                    Conta contábil de origem
                                                </th>
                                                <th style="min-width: 200px; width: 200px;">
                                                    Conta contábil de destino
                                                </th>                                                                                                
                                                <th style="min-width: 130px; width: 130px;">
                                                    Valor (R$)
                                                </th>
                                                <th style="min-width: 120px; width: 120px;">
                                                    Ações
                                                </th>                                                
                                            </thead>
                                            <tbody>   

                                                <tr v-bind:class="{'disabled': item.status == 1 || data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV != 'P'}" v-for="(item, index) in data.financeiroMovimentacoes" :key="'requisicao-verba-item-'+ item.id + '-' + index">
                                                    <td data-label="">
                                                        <span class="hidden-xl hidden-lg" style="font-size: 16px; font-weight: 500">ID: #{{item.id}}</span><span style="font-size: 16px; font-weight: 500;" class="hidden-xs">{{item.id}}</span>
                                                    </td>
                                                    <td data-label="Solicitado por">
                                                        {{item.usuario.nome}}
                                                    </td>   
                                                    <td data-label="Centro de custo de origem">
                                                       {{item.centroCustoOrigem ? item.centroCustoOrigem.DS_CENTRO_CUSTO : '-'}}
                                                    </td>
                                                    <td data-label="Centro de custo de destino">
                                                       {{item.centroCustoDestino ? item.centroCustoDestino.DS_CENTRO_CUSTO : '-'}}
                                                    </td>
                                                    <td data-label="Conta contábil de origem">
                                                       {{item.contaContabilOrigem ? item.contaContabilOrigem.DS_CONTA_CONTABIL : '-'}}
                                                    </td>
                                                    <td data-label="Conta contábil de destino">
                                                       {{item.contaContabilDestino ? item.contaContabilDestino.DS_CONTA_CONTABIL : '-'}}
                                                    </td>                                                                                                           
                                                    <td data-label="Valor">
                                                        <money v-bind="$root.config.money" type="tel" v-model="item.valor" name="quantidade" class="with-border" style="text-align: center; margin-bottom: 0px; max-width: 150px;"></money>

                                                    </td>
                                                    <td data-label="Ações">
                                                        <a v-if="!(item.status == 1 || data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV != 'P')" v-on:click="aprovarSolicitacaoVerba(item)" class="dashboard-status-button color-green block-mobile cursor-pointer" style="font-size: 15px; font-weight: 500">
                                                            <i class="las la-check-circle"></i>
                                                            Aprovar
                                                        </a>
                                                        <a v-if="item.status == 1" v-on:click="aprovarSolicitacaoVerba(item)" class="dashboard-status-button color-green block-mobile cursor-pointer" style="font-size: 15px; font-weight: 500">
                                                            <i class="las la-check-circle"></i>
                                                            Aprovada
                                                        </a>                                                        
                                                        <a v-if="!(item.status == 1 || data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV != 'P')" v-on:click="delSolicitacaoVerba(item)" class="dashboard-status-button block-mobile cursor-pointer" style="font-size: 15px; font-weight: 500; color: red;">
                                                            <i class="las la-times" style="color: red !important"></i>
                                                            Apagar
                                                        </a>                                                        
                                                    </td>                                                    
                                                    <td class="hidden-xl hidden-lg hidden-md" style="padding: 2px !important"></td>
                                                </tr>                                       
                                            </tbody>                                            
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12">
                            <div  class="row">


                                <div class="col-xl-12">
                                    <div class="dashboard-headline margin-bottom-20">
                                        <h3>
                                            <img src="static/images/icones/clipboard.png" style="height: 50px">
                                            Itens pendentes de aprovação
                                        </h3>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-xl-12 col-lg-12 margin-top-10">


                                    <div class="table-scroll" style="overflow-x: scroll; border: 1px solid #ddd">

                                        <table class="table table-bordered table-bordered-default table-responsive">
                                            <thead>
                                                <th style="min-width: 70px; width: 70px;">
                                                    Número
                                                </th>
                                                <th style="min-width: 150px; width: 150px;">
                                                    Status <small v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'P'" style="font-weight: 400; float: right">( editável )</small>
                                                </th>                                        
                                                <th style="min-width: 200px;">
                                                    Descrição
                                                </th>
                                                <th style="min-width: 200px;">
                                                    Conta contábil / Projeto
                                                </th>         
                                                <th style="min-width: 220px; width: 220px">
                                                    Centro de custo
                                                </th>                                                                                                                                  
                                                <th style="min-width: 120px;">
                                                    Saldo
                                                </th>
                                                <th style="min-width: 130px; width: 130px;">
                                                    Quantidade<br><small v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'P' && data.CLINIC_PEDIDOS_APROVACAO_V.ITEM_SERVICO != 'Títulos a pagar'" style="font-weight: 400;">( editável )</small>
                                                </th>
                                                <th style="min-width: 70px; width: 70px;">
                                                    Unidade
                                                </th>                                        
                                                <th style="min-width: 120px; width: 120px;" >
                                                    Valor unitário<br><small v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'P' && data.CLINIC_PEDIDOS_APROVACAO_V.ITEM_SERVICO == 'Títulos a pagar'" style="font-weight: 400;">( editável )</small>
                                                </th>
                                            </thead>
                                            <tbody>   

                                                <tr v-bind:class="{'disabled': data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV != 'P'}" v-for="(item, index) in data.CLINIC_ITEM_PEDIDO_APROVACAO_V" :key="'solicitacao-item-'+ item.NR_ITEM_OCI + '-' + index">
                                                    <td data-label="">
                                                        <span class="hidden-xl hidden-lg" style="font-size: 16px; font-weight: 500">Número: #{{item.NR_ITEM_OCI}}</span><span style="font-size: 16px; font-weight: 500;" class="hidden-xs">{{item.NR_ITEM_OCI}}</span>
                                                    </td>
                                                    <td data-label="Status" style="padding-left: 10px;">
                                                        <div class="checkbox" v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'P'">
                                                            <input :disabled="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV != 'P'" type="checkbox" v-model="item.status" :id="'solicitacao-item-' + item.NR_ITEM_OCI">
                                                            <label :for="'solicitacao-item-' + item.NR_ITEM_OCI" style="margin-bottom: 0px !important; font-size: 14px;"><span class="checkbox-icon"></span> Selecionado</label>
                                                        </div>              
                                                       
                                                       <span v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'B'" class="dashboard-status-button color-blue">Baixado</span>
                                                       <span v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'A'" class="dashboard-status-button color-green">Aprovado</span>
                                                       <span v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV == 'R'" class="dashboard-status-button color-red">Reprovado</span>                                                        
                                                    </td>   
                                                    <td data-label="Descrição">
                                                       {{item.DS_ITEM}}
                                                    </td>
                                                    <td data-label="Conta contábil">
                                                       {{item.DS_CONTA}}
                                                    </td>         
                                                    <td data-label="Centro de custo">
                                                       {{item.DS_CENTRO_CUSTO}}
                                                        <div v-if="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV != 'R' && data.CLINIC_PEDIDOS_APROVACAO_V.IE_TIPO == 'Despesa Corrente' && item.VL_SALDO < (parseFloat(item.VL_UNITARIO_MATERIAL) * parseFloat(item.QT_MATERIAL))" class="row margin-top-5">
                                                            <div class="col-xs-12">
                                                                <button v-on:click="openSolicitacaoVerba(item)" type="button" class="dashboard-status-button color-orange cursor-pointer" style="width: 100%; display: block; line-height: 120%; padding-top: 5px; padding-bottom: 5px;">
                                                                    <i class="las la-money-bill"></i>
                                                                    Gerar requisição de verba
                                                                </button> 
                                                            </div>                                             
                                                        </div>
                                                    </td>                                                                                                        
                                                    <td data-label="Saldo">
                                                       R$ {{item.VL_SALDO | toMoney}}
                                                    </td>
                                                    <td data-label="Quantidade">
                                                        <span v-if="data.CLINIC_PEDIDOS_APROVACAO_V.ITEM_SERVICO == 'Títulos a pagar'">{{item.QT_MATERIAL}}</span>
                                                        <input v-if="data.CLINIC_PEDIDOS_APROVACAO_V.ITEM_SERVICO != 'Títulos a pagar'" :disabled="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV != 'P'" type="number" v-model="item.QT_MATERIAL" name="quantidade" v-on:keyup="calcular" v-on:change="validacao" value="1" class="with-border" style="text-align: center; margin-bottom: 0px; max-width: 150px;">
                                                    </td>  
                                                    <td data-label="Unidade" class="td-50 td-50-l">
                                                       {{item.CD_UNIDADE_MEDIDA_COMPRA.toUpperCase()}}
                                                    </td>                                                                
                                                    <td data-label="Valor" class="td-50 ">
                                                        
                                                        <money v-if="data.CLINIC_PEDIDOS_APROVACAO_V.ITEM_SERVICO == 'Títulos a pagar'" v-bind="$root.config.money" :disabled="data.CLINIC_PEDIDOS_APROVACAO_V.IE_APROV_REPROV != 'P'" type="tel" v-model="item.VL_UNITARIO_MATERIAL" name="quantidade" v-on:keyup="calcular" v-on:change="validacao" value="1" class="with-border" style="text-align: center; margin-bottom: 0px; max-width: 150px;"></money>

                                                       <span v-if="data.CLINIC_PEDIDOS_APROVACAO_V.ITEM_SERVICO != 'Títulos a pagar'">R$ {{item.VL_UNITARIO_MATERIAL | toMoney}}</span>
                                                    </td>  
                                                    <td class="hidden-xl hidden-lg hidden-md" style="padding: 2px !important"></td>
                                                </tr>
                                                <tr class="hidden-xs">
                                                    <td colspan="8" style="text-align: right; font-weight: 500">Total</td>                    
                                                    <td style="font-weight: 600; font-size: 14px;">
                                                        R$ {{somatoria | toMoney}}                            
                                                    </td>       
                                                </tr>
                                                <tr class="hidden-xl hidden-md hidden-lg">
                                                    <td colspan="8" style="font-weight: 500">Total</td>                    
                                                    <td style="font-weight: 600; font-size: 14px; text-align: right;">
                                                        R$ {{somatoria | toMoney}}                            
                                                    </td>       
                                                </tr>                                             
                                            </tbody>
                                        </table>                              
                                    </div>
                                </div>    
                            </div>                
                        </div>                
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'FinanceiroSolicitacoesDetalhes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
        },           
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        },
        formatDate2: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            return date;
        }            
    },    
    data () {
        var self                    = this;
        return {
            "modalSolicitacaoVerba": false,
            "somatoria":            0,
            "loaded":               false,
            "data":                 {
                "CLINIC_ITEM_PEDIDO_APROVACAO_V": []
            },
            "centroCusto":          {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "NR_SEQ_APROVACAO":     null
            }              
        }
    },
    methods: {
        aprovarSolicitacaoVerba: function(item) {
            var self = this;
            console.log("aprovarSolicitacaoVerba()", item);
            confirm("Você tem certeza que deseja aprovar essa requisição?", function() {

                loading.show();

                var form = {
                    "_cod":             self.$root.user.cod, 
                    "_token":           self.$root.user.token,
                    "acao":             "aprovar-solicitacao-verba",
                    "cod":              item.cod,
                    "valor":            item.valor,
                };

                    
                axios.put("api/financeiro-solicitacoes.php", form, {"timeout": 300000})
                .then(response => {

                    console.log("aprovarSolicitacaoVerba()", "success", response.data)
                    alert(response.data.message);
                    self.get();

                })
                .catch(error => {
                    console.log("aprovarSolicitacaoVerba()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        delSolicitacaoVerba: function(item) {
            var self = this;
            console.log("delSolicitacaoVerba()", item);
            confirm("Você tem certeza que deseja apagar essa requisição?", function() {

                loading.show();

                var form = {
                    "_cod":             self.$root.user.cod, 
                    "_token":           self.$root.user.token,
                    "acao":             "solicitacao-verba",
                    "cod":              item.cod,
                };
                    
                axios.delete("api/financeiro-solicitacoes.php", {params: form}, {"timeout": 300000})
                .then(response => {

                    console.log("delSolicitacaoVerba()", "success", response.data)
                    // alert(response.data.message);
                    self.get();

                })
                .catch(error => {
                    console.log("delSolicitacaoVerba()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },        
        checkValoresSolicitacaoVerba: function() {
            var self = this;
            console.log("checkValoresSolicitacaoVerba()", self.modalSolicitacaoVerba);
            

            var total       = (parseFloat(self.modalSolicitacaoVerba.VL_UNITARIO_MATERIAL) * parseFloat(self.modalSolicitacaoVerba.QT_MATERIAL));
            console.log("total>", total);
            total           = total - parseFloat(self.modalSolicitacaoVerba.VL_SALDO);
            console.log("total>", total);
            console.log("saldo>", self.modalSolicitacaoVerba.VL_SALDO);

            var somatoria   = 0;
            self.modalSolicitacaoVerba.solicitacaoVerba.forEach(function(item, index) {
                somatoria   = somatoria + item.valor;
            });
            console.log("somatoria>", somatoria)

            var diferenca   = total - somatoria;
            console.log("diferenca>", diferenca)

            self.modalSolicitacaoVerba.solicitacaoVerba.forEach(function(item, index) {
                if (item.valor == 0 && diferenca > 0 && index > 0) {
                    console.log("valor == 0, define a diferenca");
                    self.modalSolicitacaoVerba.solicitacaoVerba[index].valor = diferenca;
                    diferenca = 0;
                }
            });

            self.$forceUpdate();
        },
        submitSolicitacaoVerba: function() {
            var self = this;
            console.log("submitSolicitacaoVerba()", self.modalSolicitacaoVerba);

            loading.show();

            var form = {
                "_cod":             self.$root.user.cod, 
                "_token":           self.$root.user.token,
                "acao":             "solicitacao-verba",
                "NR_SEQ_PROCESSO":  self.form.NR_SEQ_PROCESSO,
                "NR_SEQ_APROVACAO": self.form.NR_SEQ_APROVACAO,
                "CD_CONTA_CONTABIL": self.modalSolicitacaoVerba.CD_CONTA_CONTABIL,
                "CD_CENTRO_CUSTO":  self.modalSolicitacaoVerba.CD_CENTRO_CUSTO,
                "DS_ITEM":          self.modalSolicitacaoVerba.DS_ITEM,
                "NR_ITEM_OCI":      self.modalSolicitacaoVerba.NR_ITEM_OCI,
                "itens":            self.modalSolicitacaoVerba.solicitacaoVerba
            };
                
            axios.put("api/financeiro-solicitacoes.php", form, {"timeout": 300000})
            .then(response => {

                console.log("submitSolicitacaoVerba()", "success", response.data)
                alert(response.data.message);
                self.modalSolicitacaoVerba = null;
                self.$forceUpdate();
                self.get();

            })
            .catch(error => {

                console.log("submitSolicitacaoVerba()", "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });

        },
        addSolicitacaoVerbaItem: function() {
            var self        = this;
            console.log("addSolicitacaoVerbaItem()");
            self.modalSolicitacaoVerba.solicitacaoVerba.push({
                "valor":        0,
                "centroCusto":  ""
            });
            self.$forceUpdate();
            self.checkValoresSolicitacaoVerba();
        },
        delSolicitacaoVerbaItem: function(item) {
            var self    = this;
            var index   = self.modalSolicitacaoVerba.solicitacaoVerba.indexOf(item);
            if (index != -1) {
                self.modalSolicitacaoVerba.solicitacaoVerba.splice(index, 1);
                self.$forceUpdate();
            }            

            self.checkValoresSolicitacaoVerba();
        },
        openSolicitacaoVerba: function(item) {
            var self        = this;
            console.log("openSolicitacaoVerba()", item);

            item = JSON.parse(JSON.stringify(item));

            if (item.VL_SALDO < (parseFloat(item.VL_UNITARIO_MATERIAL) * parseFloat(item.QT_MATERIAL))) {
                var total = parseFloat(item.VL_UNITARIO_MATERIAL) * parseFloat(item.QT_MATERIAL);
                console.log("total>", item.VL_SALDO);
                // item.VL_SALDO = Math.abs(item.VL_SALDO);
                console.log("total>", item.VL_SALDO);
                item.solicitacaoVerba[0].valor = total - parseFloat(item.VL_SALDO);
            }

            self.modalSolicitacaoVerba = JSON.parse(JSON.stringify(item));
            self.$forceUpdate();
        },
        getCentroCusto: function() {
            var self        = this;
            console.log("getCentroCusto()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "centro-de-custo"
                    }
                };

                axios.get("api/financeiro.php", form)
                .then(response => {
                    
                    console.log("getCentroCusto() response", response);
                    self.centroCusto   = response.data.result; 
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCentroCusto() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        aprovar: function(tipo) {
            var self        = this;
            console.log("aprovar()");

            return new Promise(function(resolve, reject) {
                confirm("Você tem certeza que deseja aprovar os itens selecionados?", function() {

                    var itens           = [];
                    var count           = 0;
                    self.data.CLINIC_ITEM_PEDIDO_APROVACAO_V.forEach(function(item) {
                        if (item.status) {
                            count++;
                            itens.push(item.NR_ITEM_OCI);                          
                        }
                    });

                    if (itens.length == 0) {
                        alert("Nenhum item selecionado");
                        reject("Nenhum item selecionado");
                        return false;
                    }

                    console.log("Itens selecionados:", itens);

                    loading.show();

                    var form = {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "acao":         "aprovar",
                        "NR_SEQ_PROCESSO":  self.form.NR_SEQ_PROCESSO,
                        "NR_SEQ_APROVACAO": self.form.NR_SEQ_APROVACAO,
                        "itens":        self.data.CLINIC_ITEM_PEDIDO_APROVACAO_V
                    };
                        
                    axios.put("api/financeiro-solicitacoes.php", form, {"timeout": 300000})
                    .then(response => {

                        console.log("aprovar()", "success", response.data)
                        alert(response.data.message);
                        // self.get();
                        self.$root.back();
                        // loading.hide();
                        resolve(response);

                    })
                    .catch(error => {

                        reject(error);
                        console.log("aprovar()", "error", error.data)
                        loading.hide();
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                    });
                });
            });   
        },   
        negar: function(tipo) {
            var self        = this;
            console.log("negar()");

            return new Promise(function(resolve, reject) {
                confirm("Você tem certeza que deseja reprovar essa solicitação e todos os itens?", function() {

                    var motivo = prompt("Escreva o motivo da reprovação:");

                    if (!motivo) return false;

                    loading.show();

                    var form = {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "acao":         "negar",
                        "NR_SEQ_PROCESSO":  self.form.NR_SEQ_PROCESSO,
                        "DS_JUSTIFICATIVA": motivo,
                        "NR_SEQ_APROVACAO": self.form.NR_SEQ_APROVACAO,
                        "itens":        self.data.CLINIC_ITEM_PEDIDO_APROVACAO_V
                    };  

                    axios.put("api/financeiro-solicitacoes.php", form, {"timeout": 300000})
                    .then(response => {

                        console.log("negar()", "success", response.data)
                        self.$root.back();
                        
                        resolve(response);

                    })
                    .catch(error => {

                        reject(error);
                        console.log("negar()", "error", error.data)
                        loading.hide();
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                    });
                });
            });   
        },                       
        validacao: function() {
            console.log("validacao()")
            var self = this;
            self.data.CLINIC_ITEM_PEDIDO_APROVACAO_V.forEach(function(item, i) {
                console.log(">", item.QT_MATERIAL, isNaN(item.QT_MATERIAL), item);

                if (item.QT_MATERIAL == 0 || !item.QT_MATERIAL) {
                    self.data.CLINIC_ITEM_PEDIDO_APROVACAO_V[i].QT_MATERIAL = 1;
                    item.QT_MATERIAL = 1;
                    self.$forceUpdate();
                } else if (item.QT_MATERIAL.substr(0, 1) == ".") {
                    var qt = "0" + item.QT_MATERIAL;
                    self.data.CLINIC_ITEM_PEDIDO_APROVACAO_V[i].QT_MATERIAL = qt;
                }            
            });
            self.$forceUpdate();
            self.calcular();
        },
        calcular: function() {
            var self        = this;
            console.log("calcular()");

            self.somatoria = 0;

            self.data.CLINIC_ITEM_PEDIDO_APROVACAO_V.forEach(function(item, i) {
                console.log(">", item);

                var qntd = item.QT_MATERIAL;

                if (qntd == 0 || !qntd) {
                    qntd = 0;
                }   

                var sum = parseFloat(qntd) * parseFloat(item.VL_UNITARIO_MATERIAL);
                console.log("Soma", sum);

                self.somatoria = parseFloat(self.somatoria) + sum;
            });

            self.somatoria = self.somatoria.toFixed(2);
            console.log("Somatoria final", self.somatoria)

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/financeiro-solicitacoes.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.validacao();
                    self.loaded = true;
                    loading.hide();
                    self.$root.scrollTop();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        } 
    },
    created: function() {
        var self = this;
      
    },
    mounted: function() {
        var self = this;
        if (!self.$route.query.NR_SEQ_APROVACAO || !self.$route.query.NR_SEQ_PROCESSO) {
            self.$root.back();
            return false;
        }
        self.form.NR_SEQ_APROVACAO  = self.$route.query.NR_SEQ_APROVACAO;
        self.form.NR_SEQ_PROCESSO   = self.$route.query.NR_SEQ_PROCESSO;
        self.get();
        self.getCentroCusto();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .submit-field {
        margin-bottom: 15px;
    }

    .dashboard-status-button i {
        color: #fff !important;
    }

    .dashboard-status-button.block-mobile {
        text-align: center !important;
        font-weight: 400;
/*        font-size: 13px;*/
        width: 100%;
    }


    .table-color-primary {

    }

    @media only screen and (max-width: 1099px) {
        .td-50 {
            width: 50%;
            display: inline-block;
        }
        .td-50-l {
            border-right: 0px !important;
        }    
    }    


    tr.disabled {
        pointer-events: none !important;
        opacity: 0.7;
    }
</style>



// WEBPACK FOOTER //
// src/components/FinanceiroSolicitacoesDetalhes.vue